// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueI18n from 'vue-i18n';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/base.css';
import './assets/css/iconFont/iconfont.css';
import './assets/css/fontfamily/stylesheet.css';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/css/swiper.min.css';
import VueCodeMirror from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import VueClipboard from 'vue-clipboard2'
import 'vue2-animate/dist/vue2-animate.min.css'
import VueCookies from 'vue-cookies'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import zhLocale from "element-ui/lib/locale/lang/zh-CN.js"
import enLocale from "element-ui/lib/locale/lang/en.js";
import '@/components/taskDialogs/Toast/toast.scss';
import Toast from '@/components/taskDialogs/Toast/index';
import {Base64} from 'js-base64';
Vue.prototype.$Base64 = Base64;
 document.getElementsByTagName("body")[0].setAttribute("data-langs",window.localStorage.getItem("language"));
 let themeColors = window.localStorage.getItem("themeColor") ? window.localStorage.getItem("themeColor") : 'white'
  window.document.documentElement.setAttribute("data-theme",themeColors);
 let VThemes = window.document.documentElement.getAttribute("data-theme");
 import {getAjax,postAjax} from '@/api/index.js';
Vue.config.productionTip = false
if(process.env.NODE_ENV == 'development') {
    Vue.prototype.baseUrl = "/api/";

} else if(process.env.NODE_ENV == 'production') {
    Vue.prototype.baseUrl = "/";
}
if(VThemes == 'black') Vue.prototype.themeColor = "#f4a743";
if(VThemes == 'white') Vue.prototype.themeColor = "#1b9aee";
Vue.prototype.themeVal = VThemes;
let element18n = ""
if (window.localStorage.getItem("language") == "zh-ch") {
  element18n = zhLocale
}else if (window.localStorage.getItem("language") == "en") {
  element18n = enLocale
}
import preventReClick from './api/preventReClick'
Vue.use(VueAwesomeSwiper)
Vue.use(ElementUI,{ locale: element18n });
Vue.use(VueI18n);
Vue.use(VueCodeMirror);
Vue.use(VueClipboard)
Vue.use(VueCookies)
Vue.use(Toast)
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
  } })
import './assets/css/theme/common.scss';
const i18n = new VueI18n({ 
 // 默认语言
 locale: window.localStorage.getItem("language") ? window.localStorage.getItem("language") : 'zh-cn',
 // 引入对应的语言包文件
 messages: {   
    'zh-cn': require('@/assets/languages/zh-cn.json'),   
    'zh-hk': require('@/assets/languages/zh-hk.json'),   
    'en': require('@/assets/languages/en.json') 
  }
});
import $ from 'jquery'
window.jQuery = $;

//添加百度统计
var _hmt = _hmt || [];
window._hmt = _hmt; // 必须把_hmt挂载到window下，否则找不到
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?4b61783627934f7062f131c6cc69f635";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();

router.beforeEach(function (to, from, next) {

  //百度统计推送
  if (window._hmt) {
    if (to.path) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath]);
    }
  }
  if(to.query.Authorization && to.query.utype){
      window.localStorage.setItem("utype",to.query.utype)
      var reg = new RegExp( " " , "g" )
      window.localStorage.setItem("tokenId",decodeURI(to.query.Authorization).replace(reg,"+"))

  }

  let role = localStorage.getItem("utype") ? localStorage.getItem("utype") == "1" ? "stu" : "teach" : null;
  //判断是否存在token值，不存在就去登录页面去登录
  if (!localStorage.getItem("tokenId") || !localStorage.getItem("utype")) {
    if(to.meta.roles.some(record=>record == "NoValidation")){
        return  next() ;
    }else{
      return next("/Login");
    }

  }else{

    //(记忆登入)  跳转至学生/教师 首页
    if(to.path.toLowerCase() === ('/Login').toLowerCase()  && role ){
      return next({path:`/${role}`});
    }
    if(to.path.includes("enroll")){
      return  next() ;
    }
    if (to.meta.roles.includes(role)) {
      return next();
    } else {
      return  next({path: "/Login"});
    }

  }
  return next();
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js